/**
 * Returns all unique values of an array.
 */

const unique = (arr) => [...new Set(arr)];

export default unique;
